import Spinner from "utils/spinner";
import "Glonass/UI/Header";
/** @namespace Agronomy.UI */
NS("Agronomy.UI");

/**
 * @class
 * @extends Glonass.UI.Header
 */
Agronomy.UI.Header = Class(Glonass.UI.Header, /** @lends Agronomy.UI.Header.prototype */ {
    template: "Agronomy/Header",
    iconTemplate: "Agronomy/HeaderIcon",
    sysRequirementsTemplate: "Agronomy/SysRequirements",
    activeItemStyle: "selected",

    $icons: null,
    icons: {},
    $sysRequirements: null,

    initialize() {
        this.ParentCall();

        UI.Widget.Form.on("Switchable.Pop", this.onSwitchablePop, this);
    },

    render() {
        this.ParentCall();

        this.$icons = this.$name("icons");

        this.spinner = Spinner.create(this.element.querySelector('.gis-app-logo'));

        return this;
    },

    destroy() {
        this.$icons = null;
        this.$sysRequirements = null;

        this.spinner.remove() && (this.spinner = null);

        UI.Widget.Form.off("Switchable.Pop", this.onSwitchablePop, this);

        return this.ParentCall();
    },

    addIcon(name, options) {
        this.icons[name] = UI.Template.$render(this.iconTemplate, options).appendTo(this.$icons);

        return this.icons[name];
    },

    spinnerStart() {
        this.spinner.start();

        return this;
    },

    spinnerStop() {
        this.spinner.stop();

        return this;
    },

    updateAvatar() {
        this.$name("avatar").css("background-image", "url(" + Util.String.coalesce(context("profile.avatar"), "/images/gisstand/gis-user-ava.png") + ")");

        return this;
    },

    onItemClick(el) {
        if (el.getAttribute("item") === "admin" && isRoot()) {
            application.ui.workspace.showMenu();
        } else if (check(el.getAttribute("security-key"), Security.AccessMode.View)) {
            application.ui.workspace.showItem(el.getAttribute("item"));
        } else {
            alert("Доступ запрещен");
        }
    },

    onSwitchablePop(e) {
        _.defer(function() {
            const form = _.findKey(application.ui.workspace.forms, form => form === e.widget);

            if (form) {
                this.highlightItem(form);
            } else {
                this.highlightItem("admin");
            }
        }.bind(this));
    },

    highlightItem(name) {
        this.$(".gis-header-tabs-item, .gis-header .gis-user .gl-pointer").removeClass(this.activeItemStyle);
        this.$(`.gis-header-tabs-item[item="${name.split('.').shift()}"] , .gis-header .gis-user .gl-pointer[item="${name.split('.').shift()}"]`)
            .addClass(this.activeItemStyle);

        return this;
    }
});
